import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  container: {
    height: '100vh',
    width: '100%',
    backgroundColor: alpha(theme.palette.cinnamon.main, 0.5),
  },

  mainContainer: {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: theme.palette.whitePepper.main,
    height: '80vh',
    width: '100%',
    overflowY: 'scroll',
    overflowX: 'hidden',
    boxShadow: '0 25px 50px -12px rgb(0 0 0 / 0.25)',

    [theme.breakpoints.up('sm')]: {
      width: '480px',
      height: '80vh',
    },

    [theme.breakpoints.up('md')]: {
      width: '600px',
    },

    /* width */
    '&::-webkit-scrollbar': {
      width: '8px',
    },

    /* Track */
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.turmeric.main,
      borderRadius: '4px',
    },
  },

  iconWrapper: {
    display: 'flex',
    justifyContent: 'end',
    position: 'sticky',
    top: '25px',
    paddingRight: '20px',
    zIndex: 100,
  },

  closeIcon: {
    color: theme.palette.cinnamon.main,
    zIndex: 10,
    transform: 'scale(1.7)',
    cursor: 'pointer',
  },

  carouselContainer: {},

  imgContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '200px',
    [theme.breakpoints.up('md')]: {
      width: '600px',
      height: '255px',
    },
  },

  img: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '200px',
    height: '200px',
    [theme.breakpoints.up('md')]: {
      width: '250px',
      height: '250px',
    },
  },

  contentWrapper: {
    position: 'relative',
    padding: '12px',
    [theme.breakpoints.up('md')]: {
      padding: '25px 50px 50px',
    },
  },

  sides: {
    marginBottom: '10px',
  },

  requires: { marginBottom: '10px' },

  symbolWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '20px 0 15px',
  },

  startSubscriptionBtnWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '40px 0',
  },

  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
  },

  btnContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '140px',
  },
});
